import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { InputText } from 'primereact/inputtext';
import React, { useEffect, useState } from 'react';
import { FilterMatchMode } from 'primereact/api';
import { handleGetRequest } from '../../services/GetTemplate';
import { Button } from 'primereact/button';
import { ProgressSpinner } from 'primereact/progressspinner';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

function AllProducts() {
    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(5);
    const [loading, setLoading] = useState(false);
    const [globalFilterValue, setGlobalFilterValue] = useState('');

    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS }
    });
    const [products, setProducts] = useState([]);
    const [expandedRows, setExpandedRows] = useState(null);

    const navigate = useNavigate()

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };
        _filters['global'].value = value;
        setFilters(_filters);
        setGlobalFilterValue(value);
    };

    const renderHeader = () => {
        return (
            <div className="Global__Header">
                <h5 className="m-0"></h5>
                <span className="block mt-2 md:mt-0 p-input-icon-left">
                    <i className="pi pi-search" />
                    <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Search..." />
                </span>
            </div>
        );
    };

    const header = () => renderHeader();
    const onPageChange = (e) => {
        setFirst(e.first);
        setRows(e.rows);
    };

    const user = localStorage.getItem('storeName');
    const userId = localStorage.getItem('userId');
    const storeID = localStorage.getItem('storeId')
    const roleId = localStorage.getItem('roleId')

    const getAllProductsForSuperAdmin = async () => {
        setLoading(true);
        try {
            const response = await handleGetRequest('/ShopifyData/GetAllProducts', true);
            setProducts(response);
        } catch (error) {
            toast.error(error)
        }
        setLoading(false);
    }

    const getAllProducts = async () => {
        setLoading(true);
        try {
            const response = await handleGetRequest(`/ShopifyData/GetAllProducts?storeid=${storeID}`, true);
            setProducts(response);
        } catch (error) {
            toast.error(error)
        }
        setLoading(false);
    };

    useEffect(() => {
        if (roleId === 1 || roleId === '1') {
            getAllProductsForSuperAdmin();
        } else {
            getAllProducts();
        }
        
    }, []);

    const imageTemplate = (rowData) => {
        return <img src={rowData?.images?.[0]?.src} style={{ height: '50px', width: '50px' }} />;
    };
    const statusTemplate = (rowData) => {
        return <p style={{ fontWeight: '600', textTransform: 'capitalize' }}>{rowData?.product?.status}</p>;
    };

    const allowExpansion = (rowData) => {
        return rowData?.variants?.length > 0;
    };
    const rowExpansionTemplate = (rowData) => {
        const variantsData = rowData?.variants;
        
        const inventoryTemplate = (rowdata) => {
            return <p>{rowdata?.oldInventoryQuantity - rowdata?.inventoryQuantity} Sold</p>;
        };
        const priceTemplate = (rowdata) => {
            return <p>${rowdata?.price}</p>;
        };
        const weightTemplate = (rowdata) => {
            return <p>{rowdata?.weight} Kgs</p>;
        };
        const TaxTemplate = (rowdata) => {
            return <p>{rowdata?.taxable === true ? 'Yes' : 'No'}</p>;
        };
        const shippingTemplate = (rowdata) => {
            return <p>{rowdata?.requiresShipping === true ? 'Yes' : 'No'}</p>;
        };
        return (
            <div className="p-3">
                <div className="flex justify-content-center">
                    <h5>Variant Details</h5>
                </div>
                <DataTable value={variantsData}>
                    <Column field="variantId" header="Id" />
                    <Column field="sku" header="SKU" />
                    <Column field="title" header="Product Title" />
                    <Column field="barcode" header="Bar Code" />
                    <Column field="inventoryQuantity" header="Quantity in store" />
                    <Column body={priceTemplate} header="Price" />
                    <Column body={weightTemplate} header="Weight" />
                    <Column body={inventoryTemplate} header="Item Sold" />
                    <Column body={TaxTemplate} header="Taxable" />
                    <Column body={shippingTemplate} header="Shipping" />
                </DataTable>
            </div>
        );
    };
    const handleProduct = (rowData) => {
        navigate(`/product/${rowData?.product?.productId}`);
    }
    
    const ActionTemplate = (rowData) => {
        return <Button className="p-button-rounded" icon='pi pi-eye' style={{border:'none'}} onClick={()=>handleProduct(rowData)}/>;
    };

    return (
        <>
            <div className="card">
                <div className="flex justify-content-between align-items-center pb-5">
                    <h4 className="m-0">All Products</h4>
                </div>

                {loading ? (
                    <div className="flex justify-content-center align-items-center" style={{ height: '300px' }}>
                        <ProgressSpinner />
                    </div>
                ) : (
                    <DataTable
                        value={products}
                        paginator
                        rows={rows}
                        first={first}
                        onPage={onPageChange}
                        globalFilterFields={['product.id', 'product.title', 'product.handle', 'product.tags', 'product.vendor', 'product.product_type']}
                        filters={filters}
                        filterDisplay="menu"
                        header={header}
                        expandedRows={expandedRows}
                        onRowToggle={(e) => setExpandedRows(e.data)}
                        rowExpansionTemplate={rowExpansionTemplate}
                        dataKey="product.id"
                        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                        rowsPerPageOptions={[5, 10, 20]}
                    >
                        <Column expander={allowExpansion} style={{ width: '3rem' }} />
                        <Column field="product.id" header="Product Id" />
                        <Column body={imageTemplate} header="Image" />
                        <Column field="product.title" header="Product Name" />
                        <Column field="product.vendor" header="Store Name" />
                        <Column field="product.handle" header="Product Handle" />
                        <Column field="product.product_type" header="Product Type" />
                        <Column field="product.tags" header="Tags" />
                        <Column body={statusTemplate} header="Status" />
                        <Column body={ActionTemplate} header="Action" />
                    </DataTable>
                )}
            </div>
        </>
    );
}

export default AllProducts;
